<template>
  <div>
    <h1 class="title has-text-centered is-size-1 has-text-weight-light">
      {{ $t('index.administrating_reception') }}

      <span @click="loadData" :class="{ 'fa-spin': isloading }" style="cursor: pointer" class="has-text-info icon is-large">
        <i class="fas fa-sync"></i>
      </span>
    </h1>
    <template v-if="initResponse.objects">
      <div :class="['wrap', popupIsShowing ? 'collapseback' : '']">
        <div class="columns" v-for="(object, index) in initResponse.objects" :key="index">
          <div class="column is-12">
            <article class="tile is-child box">
              <p class="title has-text-weight-light is-pulled-right">
                {{ object.name }} [{{ $t('index.devices_count') }} {{ object.licenseInfo.panels == 'unlim' ? $t('index.unlim') : object.licenseInfo.panels }}]
              </p>
              <span class="tag is-danger has-text-weight-light is-pulled-right" style="margin-right: 10px; margin-top: 8px" v-if="object.licenseInfo.expired && object.licenseInfo.expired < Date.now()"
                >{{$t('index.trial_expired')}}</span
              >
              <a v-if="object.licenseInfo.byod_type != 'mauth'" class="button is-outlined is-info is-medium" @click="showAddNewKey(index, object)">
                <span>{{ $t('index.register_client_' + object.licenseInfo.byod_type) }}</span>
              </a>
              <a v-if="object.licenseInfo.byod_type == 'mauth'" class="button is-outlined is-info is-medium" @click="showAddNewKey(index, object, 'mauth')">
                <span>{{ $t('index.register_client_' + object.licenseInfo.byod_type) }}</span>
              </a>
              <br />
              <br />

              <b-tabs size="is-medium" class="block">
                <b-tab-item :label="$t('index.clients_' + object.licenseInfo.byod_type)" icon="user-circle">
                  <template v-if="activeTokens(object.tokens)">
                    <div class="wrap_table">
                      <table class="table is-striped is-fullwidth">
                        <tr>
                          <th>{{ $t('index.name') }}</th>
                          <th>{{ $t('index.tag') }}</th>
                          <th>{{ $t('index.registered_devices') }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.email') }}</th>
                          <th v-if="object.licenseInfo.byod_type == 'mauth'">{{ $t('index.phone') }}</th>
                          <th v-if="object.licenseInfo.byod_type == 'mauth'" width="20%">{{ $t('index.comment') }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.arrival_datetime_' + object.licenseInfo.byod_type) }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.departure_datetime_' + object.licenseInfo.byod_type) }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.check_frequency') }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.access_by_email') }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.custom_session_time') }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.custom_panels_limit') }}</th>
                          <th>{{ $t('index.actions') }}</th>
                        </tr>
                        <tr v-if="tokenPropVal.active" v-for="(tokenPropVal, tokenPropKey) in object.tokens" :key="tokenPropKey">
                          <td>{{ tokenPropVal.Configuration.name }}</td>
                          <td>{{ tokenPropVal.Configuration.tag }}</td>
                          <td>
                            <a v-if="tokenPropVal.devices" class="button is-outlined is-primary is-small" @click="showDevicesDialog(index, object, tokenPropKey, tokenPropVal)">
                              {{ tokenPropVal.devices.length }}&nbsp;&nbsp;
                              <i class="fas fa-mobile-alt"></i>
                            </a>
                          </td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">{{ tokenPropVal.email }}</td>
                          <!-- <td v-if="object.licenseInfo.byod_type == 'mauth'">{{ tokenPropVal.phone }}</td> -->
                          <td v-if="object.licenseInfo.byod_type == 'mauth'">{{ tokenPropVal.phone | facade('+# (###) ### - ## - ##') }}</td>
                          <td v-if="object.licenseInfo.byod_type == 'mauth'" style="white-space: pre-wrap;" width="20%"><div>{{ tokenPropVal.comment }}</div></td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">
                            <FDateTime :value="tokenPropVal.dateLifeFrom" v-if="tokenPropVal.limitType == 1" />
                            <span v-if="tokenPropVal.limitType == 2">-</span>
                          </td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">
                            <FDateTime :value="tokenPropVal.dateLifeTo" v-if="tokenPropVal.limitType == 1" />
                            <span v-if="tokenPropVal.limitType == 2">-</span>
                          </td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">{{ tokenPropVal.limitType == 2 ? tokenPropVal.frequencyCheckPeriod : '-' }}</td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">{{ tokenPropVal.bxRightId ? $t('index.yes') : '-' }}</td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">
                            <span v-if="tokenPropVal.limitType == 1 && tokenPropVal.sessionTime"> {{ tokenPropVal.sessionTime }} {{ $t('index.minutes') }} </span>
                            <span v-else> - </span>
                          </td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">
                            <span v-if="tokenPropVal.activationsCount">
                              {{ tokenPropVal.activationsCount }}
                            </span>
                            <span v-else> - </span>
                          </td>
                          <td>
                            <a v-if="object.licenseInfo.byod_type != 'mauth'" class="button table-btn is-primary is-small" @click="showEditKey(index, tokenPropKey, tokenPropVal)">
                              <span class="icon is-small">
                                <i class="fas fa-edit"></i>
                              </span>
                              <span>{{ $t('index.edit') }}</span>
                            </a>

                            <a v-if="object.licenseInfo.byod_type == 'mauth'" class="button table-btn is-primary is-small" @click="showEditKey(index, tokenPropKey, tokenPropVal, 'mauth')">
                              <span class="icon is-small">
                                <i class="fas fa-edit"></i>
                              </span>
                              <span>{{ $t('index.edit') }}</span>
                            </a>


                            <a class="button table-btn is-info is-small" @click="showPushDialog(index, tokenPropKey, tokenPropVal)">
                              <span class="icon is-small">
                                <i class="fas fa-comment"></i>
                              </span>

                              <span>{{ $t('index.send_message') }}</span>
                            </a>

                            <a class="button table-btn is-link is-small" @click="showQR(index, tokenPropKey, tokenPropVal)">
                              <!-- <i class="fas fa-lg fa-qrcode"></i> -->
                              <span class="icon is-small">
                                <i class="fas fa-qrcode"></i>
                              </span>
                              <span>{{ $t('index.qr_code') }}</span>
                            </a>
                          </td>
                          <!-- deactivate popup -->
                          <div :class="['modal customStyleModal', tokenPropVal.deleteKey ? 'is-active' : '']" style="text-align: left">
                            <div class="modal-background" @click="hidePopup((tokenPropVal.deleteKey = false))"></div>
                            <div class="modal-content">
                              <div class="box has-text-centered">
                                <h3 class="is-size-4">{{ $t('index.deactivate_confirm') }}</h3>

                                <br />
                                <div class="notification">
                                  <ul>
                                    <li>
                                      {{ $t('index.object') }}:
                                      <b>{{ object.name }}</b>
                                    </li>
                                    <li>
                                      {{ $t('index.configuration') }}:
                                      <b>{{ tokenPropVal.Configuration.name }}</b>
                                    </li>
                                    <li>
                                      <br />{{ 'index.arrival_datetime_' + object.licenseInfo.byod_type }}:
                                      <FDateTime :value="tokenPropVal.dateLifeFrom" />
                                    </li>
                                    <li>
                                      <br />{{ 'index.departure_datetime_' + object.licenseInfo.byod_type }}:
                                      <FDateTime :value="tokenPropVal.dateLifeTo" />
                                    </li>
                                  </ul>
                                </div>
                                <br />
                                <button class="button is-text" @click="hidePopup((tokenPropVal.deleteKey = false))">{{ $t('index.cancel') }}</button>
                                <button class="button is-danger" @click="deleteKey(index, object, tokenPropKey, tokenPropVal)">{{ $t('index.yes') }}</button>
                              </div>
                            </div>
                          </div>

                          <!-- push popup -->
                          <div v-if="tokenPropVal.sendingKeyValues" :class="['modal customStyleModal', tokenPropVal.messageKeyShow ? 'is-active' : '']" style="text-align: left">
                            <div class="modal-background" @click="hidePopup((tokenPropVal.messageKeyShow = false))"></div>
                            <div class="modal-content">
                              <div class="box has-text-centered">
                                <b-tabs>
                                  <b-tab-item :label="$t('index.send_push_message')" icon="comment-alt">
                                    <h3 class="is-size-4">{{ $t('index.push_message_for_connected_devices') }}</h3>
                                    <br />

                                    <div class="field">
                                      <b-field>
                                        <b-input type="textarea" v-model="tokenPropVal.sendingKeyValues.title" :placeholder="$t('index.push_message')"></b-input>
                                      </b-field>
                                    </div>


                                    <!-- <div class="field">
                                      <b-field label="JS data (for system application calls)">
                                        <b-input v-model="tokenPropVal.sendingKeyValues.js_data" type="textarea"></b-input>
                                      </b-field>
                                    </div> -->
                                    <br />
                                    <button class="button is-text" @click="hidePopup((tokenPropVal.messageKeyShow = false))">{{ $t('index.close') }}</button>
                                    <button class="button is-primary" :disabled="!tokenPropVal.sendingKeyValues.title" @click="send('push', index, object, tokenPropKey, tokenPropVal)">
                                      {{ $t('index.send') }}
                                    </button>
                                  </b-tab-item>
                                  <b-tab-item v-if="tokenPropVal.email" :label="$t('index.send_email')" icon="envelope">
                                    <!-- <h3 class="is-size-4">Email for
                                      <b>{{tokenPropVal.email}}</b>
                                    </h3> -->
                                    <h3 class="is-size-4">{{ $t('index.email_for', { email: tokenPropVal.email }) }}</h3>
                                    <br />
                                    <div class="field">
                                      <b-field>
                                        <b-input type="textarea" v-model="tokenPropVal.sendingKeyValues.title" :placeholder="$t('index.email_message')"></b-input>
                                      </b-field>
                                    </div>

                                    <br />
                                    <br />
                                    <button class="button is-text" @click="hidePopup((tokenPropVal.messageKeyShow = false))">{{ $t('index.close') }}</button>
                                    <button class="button is-info" :disabled="!tokenPropVal.sendingKeyValues.title" @click="send('email', index, object, tokenPropKey, tokenPropVal)">
                                      {{ $t('index.send') }}
                                    </button>
                                  </b-tab-item>
                                </b-tabs>
                              </div>
                            </div>
                          </div>

                          <!-- qr popup -->
                          <div v-if="tokenPropVal.showQRPopup" :class="['modal customStyleModal', tokenPropVal.showQRPopup ? 'is-active' : '']" style="text-align: left">
                            <div class="modal-background" @click="hidePopup((tokenPropVal.showQRPopup = false))"></div>
                            <div class="modal-content">
                              <div class="box has-text-centered">
                                <h3 class="is-size-4">{{ $t('index.scan_it_for_start') }}</h3>
                                <br />
                                <div class="columns is-mobile is-centered">
                                  <div class="column is-half">
                                    <qr-code :size="300" :text="generateQR(tokenPropVal.key, tokenPropVal)"></qr-code>
                                  </div>
                                </div>
                                <!-- <b-tabs
                                  position="is-centered"
                                  size="is-medium"
                                  class="block"
                                >
                                  <b-tab-item
                                    label="From camera device"
                                    icon="camera"
                                  >
                                    <div class="columns is-mobile is-centered">
                                      <div class="column is-half">
                                        <qr-code
                                          :size=300
                                          :text="generateQR(tokenPropVal.key,tokenPropVal)"
                                        ></qr-code>
                                      </div>
                                    </div>
                                    <div class="columns is-mobile is-centered">
                                      <div class="column is-half is-centered">
                                        <a
                                          class="button is-success"
                                          :href="generateQR(tokenPropVal.key,tokenPropVal)"
                                        >Open in i3 pro</a>
                                      </div>
                                    </div>
                                  </b-tab-item>
                                  <b-tab-item
                                    label="From i3pro app"
                                    icon="play"
                                  >
                                    <div class="columns is-mobile is-centered">
                                      <div class="column is-half">
                                        <qr-code
                                          :size=300
                                          :text="generateQRForApp(tokenPropVal.key,tokenPropVal)"
                                        ></qr-code>
                                      </div>
                                    </div>
                                  </b-tab-item>
                                </b-tabs> -->
                                <br />
                                <br />
                                <div class="columns">
                                  <div class="column">
                                    <template>
                                      <b-field :label="$t('index.arrival_datetime_' + object.licenseInfo.byod_type)">
                                        <FDateTime :value="tokenPropVal.dateLifeFrom" />
                                      </b-field>
                                    </template>
                                  </div>
                                  <div class="column" v-if="tokenPropVal.dateLifeTo">
                                    <template>
                                      <b-field :label="$t('index.departure_datetime_' + object.licenseInfo.byod_type)">
                                        <FDateTime :value="tokenPropVal.dateLifeTo" />
                                      </b-field>
                                    </template>
                                  </div>
                                </div>
                                <br />
                                <br />
                                <a class="button is-info" href="javascript:window.print()">{{ $t('index.print') }}</a>
                                <button v-if="tokenPropVal.email" class="button is-primary" @click="send('emailqr', index, object, tokenPropKey, tokenPropVal)">{{ $t('index.send_to_email') }}</button>
                                <button class="button is-default" @click="hidePopup((tokenPropVal.showQRPopup = false))">{{ $t('index.done') }}</button>
                              </div>
                            </div>
                          </div>

                          <!-- devices popup -->
                          <div v-if="tokenPropVal.devicesKeyShow" :class="['modal customStyleModal', tokenPropVal.devicesKeyShow ? 'is-active' : '']" style="text-align: left">
                            <div class="modal-background" @click="hidePopup((tokenPropVal.devicesKeyShow = false))"></div>
                            <div class="modal-content">
                              <div class="box has-text-centered">
                                <h3 class="is-size-4">{{ $t('index.connected_devices') }}</h3>
                                <br />
                                <table style="min-width: 100px" v-if="tokenPropVal.devices" class="table is-striped is-fullwidth">
                                  <th>{{ $t('index.model') }}</th>
                                  <!-- <th>Device name</th> -->
                                  <th>{{ $t('index.last_connect_datetime') }}</th>
                                  <th>{{ $t('index.push_sent') }}</th>
                                  <tr v-for="(device, dindx) in tokenPropVal.devices" :key="dindx">
                                    <td>{{ device.model }}</td>
                                    <!-- <td>{{device.name}}</td> -->
                                    <td>
                                      <FDateTime :value="device.lastConnect" />
                                    </td>
                                    <td>
                                      {{ device.pushCount }}
                                    </td>
                                  </tr>
                                </table>
                                <i v-else>{{ $t('index.connected_devices_not_found') }}</i>
                                <br />
                                <button class="button is-text" @click="hidePopup((tokenPropVal.devicesKeyShow = false))">{{ $t('index.close') }}</button>
                              </div>
                            </div>
                          </div>
                        </tr>
                      </table>
                    </div>
                  </template>

                  <template v-else>
                    <i>{{ $t('index.no_clients_found_' + object.licenseInfo.byod_type) }}</i>

                    <!-- <a class="button is-outlined is-info is-small" @click="showAddNewKey(index,object)">
                      <span class="icon is-small">
                        <i class="fas fa-plus"></i>
                      </span>
                      <span>Add</span>
                    </a> -->
                  </template>
                </b-tab-item>
                <b-tab-item :label="$t('index.history')" icon="history">
                  <template v-if="inactiveTokens(object.tokens)">
                    <div class="wrap_table">
                      <table class="table is-striped is-fullwidth">
                        <tr>
                          <th>{{ $t('index.name') }}</th>
                          <th>{{ $t('index.tag') }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.email') }}</th>
                          <th v-if="object.licenseInfo.byod_type == 'mauth'">{{ $t('index.phone') }}</th>
                          <th v-if="object.licenseInfo.byod_type == 'mauth'" width="15%">{{ $t('index.comment') }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.arrival_datetime_' + object.licenseInfo.byod_type) }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.departure_datetime_' + object.licenseInfo.byod_type) }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.check_frequency') }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.access_by_email') }}</th>
                          <th v-if="object.licenseInfo.byod_type != 'mauth'">{{ $t('index.custom_panels_limit') }}</th>
                          <th>{{ $t('index.actions') }}</th>
                        </tr>
                        <tr v-if="!tokenPropVal.active" v-for="(tokenPropVal, tokenPropKey) in object.tokens" :key="tokenPropKey">
                          <td>{{ tokenPropVal.Configuration.name }}</td>
                          <td>{{ tokenPropVal.Configuration.tag }}</td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">{{ tokenPropVal.email }}</td>
                          <td v-if="object.licenseInfo.byod_type == 'mauth'">{{ tokenPropVal.phone | facade('+# (###) ### - ## - ##')  }}</td>
                          <td v-if="object.licenseInfo.byod_type == 'mauth'" style="white-space: pre-wrap;" width="15%">{{ tokenPropVal.comment }}</td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">
                            <FDateTime :value="tokenPropVal.dateLifeFrom" v-if="tokenPropVal.limitType == 1" />
                            <span v-if="tokenPropVal.limitType == 2">-</span>
                          </td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">
                            <FDateTime :value="tokenPropVal.dateLifeTo" v-if="tokenPropVal.limitType == 1" />
                            <span v-if="tokenPropVal.limitType == 2">-</span>
                          </td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">{{ tokenPropVal.limitType == 2 ? tokenPropVal.frequencyCheckPeriod : '-' }}</td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">{{ tokenPropVal.bxRightId ? $t('index.yes') : '-' }}</td>
                          <td v-if="object.licenseInfo.byod_type != 'mauth'">
                            <span v-if="tokenPropVal.activationsCount">
                              {{ tokenPropVal.activationsCount }}
                            </span>
                            <span v-else> - </span>
                          </td>

                          <td>
                            <a class="button is-outlined is-small" @click="showDeleteKey(index, tokenPropKey, tokenPropVal)">
                              <span class="icon is-small">
                                <i class="fas fa-times"></i>
                              </span>
                              <span>{{ $t('index.delete') }}</span>
                            </a>
                          </td>

                          <!-- delete popup -->
                          <div :class="['modal customStyleModal', tokenPropVal.deleteKey ? 'is-active' : '']" style="text-align: left">
                            <div class="modal-background"></div>
                            <div class="modal-content">
                              <div class="box has-text-centered">
                                <h3 class="is-size-4">{{ $t('index.delete_history_key_confirm') }}</h3>
                                <span class="tag is-danger">{{ $t('index.delete_history_key_warning') }}</span>
                                <br />
                                <br />
                                <div class="notification">
                                  <ul>
                                    <li>
                                      {{ $t('index.object') }}:
                                      <b>{{ object.name }}</b>
                                    </li>
                                    <li>
                                      {{ $t('index.configuration') }}:
                                      <b>{{ tokenPropVal.Configuration.name }}</b>
                                    </li>
                                    <li>
                                      <br />{{ $t('index.arrival_datetime_' + object.licenseInfo.byod_type) }}:
                                      <FDateTime :value="tokenPropVal.dateLifeFrom" />
                                    </li>
                                    <li v-if="tokenPropVal.dateLifeTo">
                                      <br />{{ $t('index.departure_datetime_' + object.licenseInfo.byod_type) }}:
                                      <FDateTime :value="tokenPropVal.dateLifeTo" />
                                    </li>
                                  </ul>
                                </div>
                                <br />
                                <button class="button is-text" @click="hidePopup((tokenPropVal.deleteKey = false))">{{ $t('index.cancel') }}</button>
                                <button class="button is-danger" @click="deleteKey(index, object, tokenPropKey, tokenPropVal)">{{ $t('index.yes') }}</button>
                              </div>
                            </div>
                          </div>
                        </tr>
                      </table>
                    </div>
                  </template>
                  <template v-else>
                    <i>{{ $t('index.no_history_records_found') }}</i>
                  </template>
                </b-tab-item>
              </b-tabs>
            </article>
          </div>
        </div>
      </div>

      <b-modal :active.sync="addKeyShowModal" has-modal-card>
        <registertoken @init_response_push="emitInitResponsePush" @init_load_data="emitLoadData" @show_qr="emitShowQR" v-bind="addNewKeyData"></registertoken>
      </b-modal>

      <b-modal :active.sync="editKeyShowModal" has-modal-card>
        <updatetoken @init_response_update="emitInitResponseUpdate" v-bind="editKeyData"></updatetoken>
      </b-modal>

      <b-modal :active.sync="addKeyShowModalMauth" has-modal-card>
        <registermauth @init_response_push="emitInitResponsePush" @init_load_data="emitLoadData" @show_qr="emitShowQR" v-bind="addNewKeyData"></registermauth>
      </b-modal>

      <b-modal :active.sync="editKeyShowModalMauth" has-modal-card>
        <updatemauth @init_response_update="emitInitResponseUpdate" v-bind="editKeyData"></updatemauth>
      </b-modal>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import Notification from 'vue-bulma-notification';
import { Tabs, TabPane } from 'vue-bulma-tabs';
var moment = require('moment-timezone');
import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse';
import FDateTime from '../mini_components/FDateTime.vue';
import Registertoken from '../mini_components/Registertoken.vue';
import Updatetoken from '../mini_components/Updatetoken.vue';
import Registermauth from '../mini_components/Registermauth.vue';
import Updatemauth from '../mini_components/Updatemauth.vue';
import Buefy from 'buefy';
import VueQRCodeComponent from 'vue-qrcode-component';

import { InputFacade, facade, filter } from 'vue-input-facade'

Vue.use(Buefy, {
  defaultIconPack: 'fas',
});

Vue.component('qr-code', VueQRCodeComponent);
Vue.use(Buefy);

const NotificationComponent = Vue.extend(Notification);

const openNotification = (
  propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications',
  }
) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData,
  });
};

export default {
  components: {
    Tabs,
    TabPane,
    Collapse,
    CollapseItem,
    Notification,
    FDateTime,
    Registertoken,
    Updatetoken,
    Registermauth,
    Updatemauth,
    InputFacade,
  },
  directives: { facade },
  filters: { facade: filter },
  data() {
    const today = new Date();

    return {
      showRightModal: false,
      popupIsShowing: false,
      data: {},
      initResponse: {},
      param: {},
      isloading: false,
      showNewConfigInput: false,
      newConfigName: '',
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),

      I3PRO_APPSTORE: 'https://itunes.apple.com/us/app/i3-pro/id1039770224?l=ru&ls=1&mt=8',
      I3PRO_APPSTORE_CH: 'https://itunes.apple.com/cn/app/iridi-i3-pro/id1420050730?l=ru&ls=1&mt=8',
      I3PRO_GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.iridium.i3pro_v100',
      I3PRO_ANDROID_APK: 'https://iridi.com/redirects/?go=i3_pro_Android',
      addNewKeyData: {
        objIndx: 0,
        objData: {},
      },
      editKeyData: {
        objIndx: 0,
        objData: {},
        tokenIndex: 0,
        tokenVal: {},
      },
      addKeyShowModal: false,
      editKeyShowModal: false,

      addKeyShowModalMauth: false,
      editKeyShowModalMauth: false,
    };
  },
  mounted() {
    this.loadData();
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
  },
  methods: {
    emitInitResponsePush(payload) {
      this.initResponse.objects[payload.objIndex].tokens.push(payload.tokenData);
      // this.loadData()
    },
    emitInitResponseUpdate(payload) {
      this.$set(this.initResponse.objects[payload.objIndex].tokens, payload.tokIndex, payload.tokenData);
      // this.loadData()
    },
    emitShowQR(payload) {
      console.log('emitShowQR', payload);
      this.showQR(payload.objIndex, this.initResponse.objects[payload.objIndex].tokens.length - 1, payload.tokenData);
    },
    emitLoadData() {
      this.loadData();
    },
    hidePopup(prop) {
      this.popupIsShowing = false;
    },
    activeTokens(tokens) {
      return tokens.filter((t) => t.active).length > 0;
    },
    inactiveTokens(tokens) {
      return tokens.filter((t) => !t.active).length > 0;
    },
    showDeleteKey(objIndex, tokIndex, tokenObj) {
      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'deleteKey', true);
      this.popupIsShowing = true;
    },
    showAddNewKey(objIndex, objectData, authType='') {
      if (authType == 'mauth') {
        this.$set(this.initResponse.objects[objIndex], 'addKeyShow', true);
        this.addKeyShowModalMauth = true;
      } else {
        this.$set(this.initResponse.objects[objIndex], 'addKeyShow', true);
        this.addKeyShowModal = true;
      }

      // this.$set(this.initResponse.objects[objIndex], 'addKeyShow', true);
      // this.addKeyShowModal = true;

      //this.popupIsShowing = true;

      let dateLifeFrom = new Date();
      let dateLifeTo = new Date();
      dateLifeTo.setDate(dateLifeTo.getDate() + 1);

      let dayToday = new Date();

      if (objectData.defDepartureTime) {
        let defDepartureTime = new Date(objectData.defDepartureTime);
        dateLifeTo.setHours(defDepartureTime.getHours(), defDepartureTime.getMinutes(), 0);
      }

      if (objectData.defArrivalTime) {
        let defArrivalTime = new Date(objectData.defArrivalTime);
        dateLifeFrom.setHours(defArrivalTime.getHours(), defArrivalTime.getMinutes(), 0);
      }

      this.$set(this.initResponse.objects[objIndex], 'newKeyValues', {
        configurationId: '',
        objectId: objectData.objectId,
        comment: '',
        email: '',
        limit: 1,
        dateLifeTo: dateLifeTo,
        dateLifeFrom: dateLifeFrom,
        sessionTimeOption: false,
        sessionTimeValue: '',
        clientName: '',
        limitType: objectData.defLimitType || 1,
        frequencyCheckPeriod: objectData.defFrequencyCheckPeriod || 7,
        activationsCount: objectData.defActivationsCount || 2,
      });

      this.addNewKeyData = {
        objIndx: objIndex,
        objData: this.initResponse.objects[objIndex],
      };
    },
    showEditKey(objIndex, tokIndex, tokenObj, authType='') {
      if (authType == 'mauth') {
        this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'editKeyShow', true);
        this.editKeyShowModalMauth = true;
      } else {
        this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'editKeyShow', true);
        this.editKeyShowModal = true;
      }

      // this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'editKeyShow', true);
      // this.editKeyShowModal = true;
      //this.popupIsShowing = true;
      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'editKeyValues', {
        deactivated: false,
        comment: tokenObj.comment,
        clientName: tokenObj.clientName || '',
        email: tokenObj.email,
        phone: tokenObj.phone,
        dateLifeFrom: new Date(tokenObj.dateLifeFrom),
        dateLifeTo: new Date(tokenObj.dateLifeTo),
        configurationId: tokenObj.configurationId,
        sessionTimeOption: tokenObj.sessionTime ? true : false,
        sessionTimeValue: tokenObj.sessionTime,

        limitType: tokenObj.limitType,
        proLogin: tokenObj.bxRightId ? true : false,
        frequencyCheckPeriod: tokenObj.frequencyCheckPeriod,
        activationsCount: tokenObj.activationsCount,
      });

      this.editKeyData = {
        objIndx: objIndex,
        objData: this.initResponse.objects[objIndex],
        tokenIndex: tokIndex,
        tokenVal: this.initResponse.objects[objIndex].tokens[tokIndex],
      };
    },

    showPushDialog(objIndex, tokIndex, tokenObj) {
      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'messageKeyShow', true);
      this.popupIsShowing = true;
      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'sendingKeyValues', {
        sound_type: 0,
        js_data: '',
        title: '',
      });
    },
    showDevicesDialog(objIndex, objectData, tokIndex, tokenObj) {
      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'devicesKeyShow', true);
      this.popupIsShowing = true;
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/token/get`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: {
          timezone: moment.tz.guess(),
          keyId: tokenObj.id,
          objectId: objectData.objectId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.openNotificationWithType('danger', '', response.data.error);
            this.openNotificationWithType('danger', '', response.data.error_code ? this.$t(`index.jwt_errors.${response.data.error_code}`) : response.data.error);
          } else {
            this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'devices', response.data.tokenRes.devices);
          }
        })
        .catch((error) => {
          this.openNotificationWithType('danger', '', error);
        });
    },
    showQR(objIndex, tokIndex, tokenObj) {
      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'showQRPopup', true);
      this.popupIsShowing = true;
    },
    generateQR(key, tokenVal) {
      let dataPayload = `[config=${tokenVal.Configuration.name}|name=${tokenVal.clientName}]`;

      let appLink = encodeURIComponent(`byod/?key=${key}&data=`);
      return `https://iridi.com/qr_run/?link=${appLink}`;
    },
    generateQRForApp(key, tokenVal) {
      let dataPayload = `[config=${tokenVal.Configuration.name}|name=${tokenVal.clientName}]`;
      return `i3pro://byod/?key=${key}&data=${dataPayload}`;
    },
    deleteKey(objIndex, objectData, tokIndex, tokenObj) {
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/keys/destroy`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: {
          timezone: moment.tz.guess(),
          keyId: tokenObj.id,
          objectId: objectData.objectId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.openNotificationWithType('danger', '', response.data.error);
            this.openNotificationWithType('danger', '', response.data.error_code ? this.$t(`index.jwt_errors.${response.data.error_code}`) : response.data.error);
          } else {
            if (tokenObj.bxRightId) {
              this.$http({
                method: 'post',
                url: `https://iridi.com/customer/api_byod/?act=delete_right`,
                data: { bxRightId: tokenObj.bxRightId },
              })
                .then((bitixResponse) => {
                  if (bitixResponse.data.status != 'success') {
                    this.openNotificationWithType('danger', '', this.$t('index.'+ bitixResponse.data.code));
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }

            this.hidePopup();
            if (response.data.isDestroyed) {
              this.initResponse.objects[objIndex].tokens.splice(tokIndex, 1);
            }
            // this.loadData()
          }
        })
        .catch((error) => {
          this.openNotificationWithType('danger', '', error);
        });
    },
    send(type, bjIndex, objectData, tokIndex, tokenObj) {
      let payload = {};
      switch (type) {
        case 'push':
          payload = {
            timezone: moment.tz.guess(),
            keyId: tokenObj.id,
            objectId: objectData.objectId,
            sendData: tokenObj.sendingKeyValues,
          };
          tokenObj.sendingKeyValues.sound_type = parseInt(tokenObj.sendingKeyValues.sound_type);
          break;

        case 'email':
          payload = {
            timezone: moment.tz.guess(),
            keyId: tokenObj.id,
            objectId: objectData.objectId,
            sendData: tokenObj.sendingKeyValues,
          };
          break;

        case 'emailqr':
          payload = {
            timezone: moment.tz.guess(),
            keyId: tokenObj.id,
            objectId: objectData.objectId,
            sendData: tokenObj.sendingKeyValues,
            qr: true,
          };
          break;
      }

      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/token/send/${type}`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: payload,
      })
        .then((response) => {
          if (response.data.status) {
            // this.openNotificationWithType('danger', '', response.data.error);
            this.openNotificationWithType('danger', '', response.data.error_code ? this.$t(`index.jwt_errors.${response.data.error_code}`) : response.data.error);
          } else {
            switch (type) {
              case 'email':
              case 'emailqr':
                this.openNotificationWithType('success', '', this.$t('index.email_successfuly_sended'));
                break;
              case 'push':
                const messageType = response.data.successCount ? 'success' : 'danger'
                this.openNotificationWithType(messageType, '',
                  this.$t('index.push_successfuly_sended',{ msgSuccess: response.data.successCount,  msgError: response.data.failureCount})
                );
                break;
            }
          }
        })
        .catch((error) => {
          this.openNotificationWithType('danger', '', error);
        });
    },
    addNewKey(objIndex, objectData) {
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/keys/add`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: {
          timezone: moment.tz.guess(),
          comment: objectData.newKeyValues.comment,
          clientName: objectData.newKeyValues.clientName,
          email: objectData.newKeyValues.email,
          configurationId: objectData.newKeyValues.configurationId,
          objectId: objectData.newKeyValues.objectId,
          limit: 1,
          dateLifeTo: objectData.newKeyValues.dateLifeTo.getTime(),
          dateLifeFrom: objectData.newKeyValues.dateLifeFrom.getTime(),
          sessionTime: !objectData.newKeyValues.sessionTimeOption ? null : objectData.newKeyValues.sessionTimeValue,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.openNotificationWithType('danger', '', response.data.error);
            this.openNotificationWithType('danger', '', response.data.error_code ? this.$t(`index.jwt_errors.${response.data.error_code}`) : response.data.error);
          } else {
            this.initResponse.objects[objIndex].tokens.push(response.data.tokenData);
            this.$set(this.initResponse.objects[objIndex], 'addKeyShow', false);
            if (objectData.showQrCode) {
              //show qr imidiately

              this.showQR(objIndex, this.initResponse.objects[objIndex].tokens.length - 1, response.data.tokenData);
            } else {
              this.hidePopup();
            }
          }
        })
        .catch((error) => {
          this.openNotificationWithType('danger', '', error);
        });
    },
    openNotificationWithType(type, title, message) {
      openNotification({
        title: title,
        message: message,
        type: type,
      });
    },
    getRightClass(id) {
      return id === null ? 'blend' : '';
    },
    toggleFormInvite(obj) {
      obj.newRightForm = !obj.newRightForm;
      if (obj.objType === 3) {
        obj.Macros = 0;
        obj.Routines = 0;
        obj.Schedules = 0;
      }
    },
    loadData() {
      this.isloading = true;
      this.data.length = 0;
      this.$http({
        url: `${this.$backendHost}/frontend/api/init/reseption`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
      })
        .then((response) => {
          if (response.data.error) {
            // this.openNotificationWithType('danger', '', response.data.error);
            this.openNotificationWithType('danger', '', response.data.error_code ? this.$t(`index.jwt_errors.${response.data.error_code}`) : response.data.error);
          } else {
            this.$set(this, 'initResponse', response.data);
          }

          this.isloading = false;
        })
        .catch((error) => {
          this.isloading = false;
          this.openNotificationWithType('danger', '', error);
        });
    },
  },
};
</script>

<style>
.tab-content {
  margin: 10px 0px !important;
}
tr.blend {
  opacity: 0.3;
}

.tab-list a {
  font-size: 1.1rem;
}
.pointer {
  cursor: pointer;
}
</style>

<style lang="scss">
.collapseback {
  height: calc(100vh - 168px);
  overflow: hidden;
  box-sizing: border-box;
}
.customStyleModal {
  padding: 20px;
  .modal-background {
    background-color: #f5f5f5;
  }

  .modal-content {
    overflow: auto;
  }
}
.styles-box .notification {
  margin-bottom: 20px;
  line-height: 1.25;
}

.blended {
  opacity: 0.3;
}

.wrap_table {
  overflow-x: auto;

  table {
    min-width: 480px;

    td:first-child {
      text-align: left;
    }

    th:first-child {
      text-align: left;
    }
  }

  .table td,
  .table th {
    vertical-align: middle;
    text-align: center;
  }
  .table th {
    font-weight: 500;
  }
}

@media print {
  aside {
    display: none;
  }

  .app-navbar {
    display: none;
  }

  .app-main {
    margin: 0 !important;
    padding: 0;
  }

  .modal-content,
  .modal-card {
    max-height: 100vh;
  }

  .button {
    display: none;
  }
}

.table-btn {
  margin-bottom: 3px;
}
.qrapps img {
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  .customStyleModal {
    .modal-content {
      margin: 0 auto;
      max-height: calc(100vh - 140px);
      width: 95%;
    }
  }
}

@media screen and (min-width: 768px) {
  .customStyleModal {
    .modal-content {
      margin: 0 auto;
      max-height: calc(100vh - 140px);
      width: 640px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?1a81388c